/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SurveyUploadResponseDto } from '../models';
/**
 * SurveyApi - axios parameter creator
 * @export
 */
export const SurveyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload survey from Excel file
         * @param {File} file Excel file with survey data
         * @param {string} name Survey name
         * @param {number} certificationId Certification ID. The uploaded survey is created as a SURVEY stage within this certification.
         * @param {string} [deadline] Survey deadline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSurvey: async (file: File, name: string, certificationId: number, deadline?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadSurvey', 'file', file)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('uploadSurvey', 'name', name)
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('uploadSurvey', 'certificationId', certificationId)
            const localVarPath = `/api/v2/surveys/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (deadline !== undefined) { 
                localVarFormParams.append('deadline', deadline as any);
            }
    
            if (certificationId !== undefined) { 
                localVarFormParams.append('certificationId', certificationId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyApi - functional programming interface
 * @export
 */
export const SurveyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Upload survey from Excel file
         * @param {File} file Excel file with survey data
         * @param {string} name Survey name
         * @param {number} certificationId Certification ID. The uploaded survey is created as a SURVEY stage within this certification.
         * @param {string} [deadline] Survey deadline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSurvey(file: File, name: string, certificationId: number, deadline?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyUploadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSurvey(file, name, certificationId, deadline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.uploadSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyApi - factory interface
 * @export
 */
export const SurveyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyApiFp(configuration)
    return {
        /**
         * 
         * @summary Upload survey from Excel file
         * @param {File} file Excel file with survey data
         * @param {string} name Survey name
         * @param {number} certificationId Certification ID. The uploaded survey is created as a SURVEY stage within this certification.
         * @param {string} [deadline] Survey deadline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSurvey(file: File, name: string, certificationId: number, deadline?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyUploadResponseDto> {
            return localVarFp.uploadSurvey(file, name, certificationId, deadline, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyApi - interface
 * @export
 * @interface SurveyApi
 */
export interface SurveyApiInterface {
    /**
     * 
     * @summary Upload survey from Excel file
     * @param {File} file Excel file with survey data
     * @param {string} name Survey name
     * @param {number} certificationId Certification ID. The uploaded survey is created as a SURVEY stage within this certification.
     * @param {string} [deadline] Survey deadline
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApiInterface
     */
    uploadSurvey(file: File, name: string, certificationId: number, deadline?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyUploadResponseDto>;

}

/**
 * SurveyApi - object-oriented interface
 * @export
 * @class SurveyApi
 * @extends {BaseAPI}
 */
export class SurveyApi extends BaseAPI implements SurveyApiInterface {
    /**
     * 
     * @summary Upload survey from Excel file
     * @param {File} file Excel file with survey data
     * @param {string} name Survey name
     * @param {number} certificationId Certification ID. The uploaded survey is created as a SURVEY stage within this certification.
     * @param {string} [deadline] Survey deadline
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public uploadSurvey(file: File, name: string, certificationId: number, deadline?: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).uploadSurvey(file, name, certificationId, deadline, options).then((request) => request(this.axios, this.basePath));
    }
}

